var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * hbox
 */
import * as lodash from '../../utils/lodash';
import { getPercentOrNumberValue } from '../../utils/math';
import Box from './box';
import { flexLayout } from '../flexlayout';
var VBox = /** @class */ (function (_super) {
    __extends(VBox, _super);
    function VBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'vbox';
        return _this;
    }
    VBox.prototype.getContentSize = function () {
        this.children.forEach(function (child) { return child.computeSize(); });
        var contentWidth = lodash.max(this.children.map(function (child) { return child.minSize[0]; })) || 0;
        var contentHeight = lodash.sum(this.children.map(function (child) { return child.minSize[1]; }));
        return [contentWidth, contentHeight];
    };
    VBox.prototype.layout = function () {
        var contentBox = this.getContentBox();
        this.children.forEach(function (child) {
            var propsHeight = child.props.height;
            var minHeight = child.minSize[1];
            var h;
            if (propsHeight) {
                h = getPercentOrNumberValue(propsHeight, contentBox.height);
            }
            else {
                h = minHeight;
            }
            child.bbox.height = h;
            if (lodash.isString(child.props.width)) {
                child.bbox.width = (parseFloat(child.props.width) / 100) * contentBox.width;
            }
            else {
                child.bbox.width = child.minSize[0];
            }
        });
        var contentHeight = lodash.sum(this.children.map(function (child) { return child.bbox.height; }));
        var leftHeight = contentBox.height - contentHeight;
        var flexItems = this.children.filter(function (child) { return child.props.flex > 0; });
        var flexValues = flexItems.map(function (item) { return item.props.flex; });
        var totalFlex = lodash.sum(flexValues);
        var flexGrow = flexValues.map(function (flex) { return (flex / totalFlex) * leftHeight; });
        flexItems.forEach(function (item, index) {
            item.bbox.height += flexGrow[index];
        });
        flexLayout(contentBox, this.children.map(function (child) { return child.bbox; }), 'vbox', this.props.align, this.props.pack);
        this.children.forEach(function (child) { return child.layout(); });
    };
    return VBox;
}(Box));
export default VBox;
